import Layout from "../include/layout";
import { Button, Container, Form, Modal, Table } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from "dayjs";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "datatables.net-bs5";
import coursService from "./CoursService";
import Filarial from "../include/filarial";
import PersonnesService from "../personnes/PersonnesService";
import MatieresService from "../matieres/MatieresService";
import PaysService from "../pays/PaysService";
import ClassesoptionsService from "../classesoptions/ClassesoptionsService";
import ClassesService from "../classe/ClassesService";
import CoursService from "./CoursService";
import EnseignantsService from "../enseignants/EnseignantsService";
import UsersService from "../users/UsersService";

export default function CoursIndex() {
  const activeLink = "Cours";

  const navigate = useNavigate();
  //check if user is authenticated
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticate);

  ///les elements du modal details
  const token = useSelector((state) => state.auth.token);
  const [matiere, setMatiere] = useState("");
  const [matieres, setMatieres] = useState([]);
  const [classeoption, setClasseoption] = useState("");
  const [classesoptions, setClassesoptions] = useState([]);
  const [enseignantId, setEnseignantId] = useState("");
  const [enseignants, setEnseignants] = useState([]);
  const [personnes, setPersonnes] = useState([]);
  const [jours, setJours] = useState([]);
  const [jour, setJour] = useState("");
  const [heureDebut, setHeureDebut] = useState("");
  const [heureFin, setHeureFin] = useState("");
  const [descriptionCours, setDescriptionCours] = useState("");
  const [anneeacademique, setAnneeacademique] = useState("");
  const [anneesacademiques, setAnneesacademiques] = useState([]);
  const [users, setUsers] = useState([]);
  const [cours, setCours] = useState([]);
  const [nom, setNom] = useState("");
  const [prenoms, setPrenoms] = useState("");
  


  //Enseignant sélectionné
  const [idElement, setIdElement] = useState("");

  //get liste enseignants
  const fetchEnseignants = async () => {
    await EnseignantsService.index(token)
      .then((res) => {
        //console.log(res.data.data)
        setEnseignants(res.data.data.enseignants);
      })
      .catch((error) => {
        console.log(error);
      });
  };

   //get liste cours
   const fetchCours = async () => {
    await CoursService.index(token).then((res) => {
      //  console.log(res.data.data.cours)
        setCours(res.data.data.cours)
    }).catch(error => {
        console.log(error)
    })
    
     //initialize datatable
     $(document).ready(function () {
      $('.data-table').DataTable();
  });
}

  ///Get liste des classes options
  const fetchClassesoptions = async () => {
    await ClassesoptionsService.index(token)
      .then((res) => {
        //console.log(res.data.data)
        setClassesoptions(res.data.data.classesoptions);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //get liste personnes
  const fetchPersonnes = async () => {
    await PersonnesService.index(token)
      .then((res) => {
        //  console.log(res.data.data.personnes)
        setPersonnes(res.data.data.personnes);
      })
      .catch((error) => {
        console.log(error);
      });
  };

   //get liste users
   const fetchUsers = async () => {
    await UsersService.index(token)
      .then((res) => {
        setUsers(res.data.data.users);
      })
      .catch((error) => {
        console.log(error);
      });
  };



     //get liste jours
     const fetchJours = async () => {
      await CoursService.index_jours(token).then((res) => {
          setJours(res.data.data.jours)
      }).catch(error => {
          console.log(error)
      })
  }

  
  //get liste matières
  const fetchMatieres = async () => {
    await MatieresService.index(token)
      .then((res) => {
        //console.log(res.data.data)
        setMatieres(res.data.data.matieres);
      })
      .catch((error) => {
        console.log(error);
      });
  };


  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  //redirection sur la page edit sans afficher les id dans l'url
  const goToEdit = (param) => {
    navigate(myroutes.cours_edit, { state: { id: param } });
  };

  //suppression d'un élément
  const onDelete = (param) => {
    //confirm action
    Swal.fire({
      icon: "warning",
      text: "Voulez-vous confirmer cette action ?",
      showCancelButton: true,
      cancelButtonText: "Non",
      confirmButtonText: "Oui",
      confirmButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        CoursService.delete(param, token)
          .then((response) => {
            if (response.data.status !== 200) {
              Swal.fire({
                icon: "error",
                text: response.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                text: response.data.message,
              });
              fetchCours();
            }
          })
          .catch((e) => {
            Swal.fire({
              icon: "error",
              text: e.message,
            });
            console.log(e);
          });
      }
    });
  };

  //Afficher le modal de détail user
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

    const handleDetails = (id) => {
      const cour = cours.find((e) => e.id === id);
      const personne = cour.enseignants.personnes;
       const nom = personne.nomPersonne;
      const prenoms = personne.prenomsPersonne;
      const matiere = cour.matieres
        ? cour.matieres.libelleMatiere
        : "Aucune matière associée";
        const anneeacademique1 = cour.anneesacademiques
        ? cour.anneesacademiques.anneedebutAnneeacademique
        : "Aucune année académique associée";

        const anneeacademique2 = cour.anneesacademiques
        ? cour.anneesacademiques.anneefinAnneeacademique
        : "Aucune année académique associée";

        const anneeacademique = anneeacademique1 + ' - ' + anneeacademique2

        const classeoption = cour.classesoptions
        ? cour.classesoptions.libelleClasseOption: "Aucune classeoption associée";
        ;

        const jour = cour.jours
        ? cour.jours.libelleJour: "Aucun jour associé";
        ;

        
  
      // Mettez à jour l'état local avec les détails du cours spécifique
      setMatiere(matiere);
      setAnneeacademique(anneeacademique);
      setClasseoption(classeoption);
      setNom(nom)
      setPrenoms(prenoms)
      setJour(jour)
      setHeureDebut(cour.heuredebutCours)
      setHeureFin(cour.heurefinCours)
      handleShow();
    };


  useEffect(() => {
    fetchEnseignants();
    fetchPersonnes();
    fetchMatieres();
    fetchClassesoptions();
    fetchUsers();
    fetchCours();
    fetchJours();
    // Vérifier si l'utilisateur est connecté lors du chargement de l'application
    dispatch(checkAuthenticate());
    if (!isAuthenticated) {
      //console.log(isAuthenticated)
      //Redirection sur le dashboard
      navigate(myroutes.login);
    }
  }, [dispatch]);

  return (
    <Layout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Filarial activeLink={activeLink} />

        {/* Responsive Datatable */}
        <div className="card shadow-lg mb-3 mt-3">
          <h5 className="card-header">
            Liste des cours{" "}
            <Link
              className="btn btn-primary btn-sm"
              to={myroutes.cours_create}
              title="Ajouter"
            >
              <FontAwesomeIcon icon="fa-solid fa-circle-plus" />
            </Link>
          </h5>
          <div className="card-datatable table-responsive px-4 pb-3">
            <table className="dt-responsive table border-top data-table table-hover ">
              <thead className="fw-bold theme-bg-blue-white ">
                <tr style={{ color: "" }}>
                  <th className="cell">#</th>
                  <th className="cell">Classe option</th>
                  <th className="cell">Matiere</th>
                  <th className="cell">Enseignant</th>
                  <th className="cell">Jour</th>
                  <th className="cell">Heure Debut</th>
                  <th className="cell">Heure Fin</th>
                  <th className="cell">Date modifcation</th>
                  <th className="cell">Action</th>
                </tr>
              </thead>
              <tbody>
                {cours.length > 0 &&
                  cours.map((item, index) => (
                    <tr key={index}>
                      <td className="cell">
                        {index + 1}
                      </td>
                      <td className="cell">
                        {item.classesoptions.libelleClasseOption}
                      </td>
                      <td className="cell">{item.matieres.libelleMatiere}</td>
                      <td className="cell">{item.enseignants.personnes.nomPersonne + ' ' + item.enseignants.personnes.prenomsPersonne}</td>
                      <td className="cell">{item.jours.libelleJour}</td>
                      <td className="cell">{item.heuredebutCours.substring(0, 5)}</td>
                      <td className="cell">
                        {item.heurefinCours.substring(0, 5)}
                      </td>
                      <td className="cell">
                        <span>
                          {dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}
                        </span>
                      </td>
                      <td className="cell">
                        <div className="d-flex">
                          <Button
                            className="btn btn-sm rounded-5"
                            variant="success"
                            onClick={() => handleDetails(item.id)}
                            title="Détails"
                          >
                            <FontAwesomeIcon icon="fa-solid fa-list" />
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            className="btn btn-sm"
                            variant="primary"
                            onClick={() => goToEdit(item.id)}
                            title="Modifier"
                          >
                            <i className="fas fa-edit"></i>
                          </Button>{" "}
                          &nbsp;&nbsp;
                          <Button
                            className="btn btn-sm"
                            variant="danger"
                            onClick={() => onDelete(item.id)}
                            title="Supprimer"
                          >
                            <i className="fas fa-trash"></i>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        {/*/ Responsive Datatable */}
        {/* /Bootstrap Validation */}

        <>
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title className="text-white">
                Détails d'une programmation
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div className="row">
                  <div className="col-md-12">
                    <div className="row">
                      <div
                        className="col-md-6"
                        style={{
                          borderRight: "1px solid rgb(225, 224, 224)",
                        }}
                      >
                        <div className="col-md-12 ">
                          <div className="row">
                            <div className="col-md-12 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="nomprenoms"
                              >
                              Année académique                              
                              </Form.Label>
                              <Form.Control
                                className=""
                                value={anneeacademique}
                                aria-label="nomprenoms"
                                type="text"
                                readOnly
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-6"
                        style={{
                        }}
                      >
                        <div className="col-md-12 ">
                          <div className="row">
                            <div className="col-md-12 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="nomprenoms"
                              >
                              Classe option                              
                              </Form.Label>
                              <Form.Control
                                className=""
                                value={classeoption}
                                aria-label="nomprenoms"
                                type="text"
                                readOnly
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-md-6"
                        style={{
                          borderRight: "1px solid rgb(225, 224, 224)",
                        }}
                      >
                        <div className="col-md-12 ">
                          <div className="row">
                            <div className="col-md-12 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="nomprenoms"
                              >
                              Matière                              
                              </Form.Label>
                              <Form.Control
                                className=""
                                value={matiere}
                                aria-label="nomprenoms"
                                type="text"
                                readOnly
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-6"
                        style={{
                        }}
                      >
                        <div className="col-md-12 ">
                          <div className="row">
                            <div className="col-md-12 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="nomprenoms"
                              >
                              Nom et prénom (s) de l'enseignant                              
                              </Form.Label>
                              <Form.Control
                                className=""
                                value={nom + ' ' + prenoms}
                                aria-label="nomprenoms"
                                type="text"
                                readOnly
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-md-6"
                        style={{
                          borderRight: "1px solid rgb(225, 224, 224)",
                        }}
                      >
                        <div className="col-md-12 ">
                          <div className="row">
                            <div className="col-md-12 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="jour"
                              >
                              Jour                              
                              </Form.Label>
                              <Form.Control
                                className=""
                                value={jour}
                                aria-label="jour"
                                type="text"
                                readOnly
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-6"
                        style={{
                        }}
                      >
                        <div className="col-md-12 ">
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor=""
                              >
                              heure début                              
                              </Form.Label>
                              <Form.Control
                                className=""
                                value={heureDebut.substring(0, 5)}
                                aria-label=""
                                type="text"
                                readOnly
                                disabled
                              />
                            </div>
                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor=""
                              >
                              heure fin                              
                              </Form.Label>
                              <Form.Control
                                className=""
                                value={heureFin.substring(0, 5)}
                                aria-label=""
                                type="text"
                                readOnly
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Fermer
                </Button>
                <Button
                  variant="primary"
                  type="button"
                  onClick={() => goToEdit(idElement)}
                >
                  Modifier
                </Button>
              </Modal.Footer>
            </Modal.Body>
          </Modal>
        </>
      </div>
    </Layout>
  );
}
